<div *ngIf="info" class="special-plate-info d-flex align-items-start gap-3 p-3 mt-3 rounded">
  <mat-icon class="special-plate-info__icon flex-shrink-0">{{ info.icon }}</mat-icon>
  <div>
    <p class="fw-semibold mb-1">{{ info.title }}</p>
    <p class="mb-0 fs-6 text-muted">{{ info.description }}</p>
  </div>
</div>
